import { Dispatch } from 'redux';
import toast from '../../../../utils/toast';
import { publishSelectedAssetsToEndPoints } from '../../../../state/publishAssets';
import { getThumbnail } from './getThumbnail';
import { createAsset } from './createAsset';
import { ActionStatus, ActionType, IMetadata } from '../../../../api/vault/assetStatus/interfaces';
import { PublishRenditionType } from '../../../../api/vault/publishAssets';
import { IAppState } from '../../../../state/reducers';
import { createAssetStatus } from '../../../../api/vault/assetStatus/api';
import { IPublishMetadata, IPublishSettings } from '../../../../api/vault/publishEndpoints';

interface ICreateAndPublishAssetParams {
  newAssetTitle: string;
  publishSettings: IPublishSettings<any>[];
  publishMetadata: IPublishMetadata;
  isVaultSuperAdmin: boolean;
}

export function createAndPublishAsset({
  newAssetTitle,
  publishSettings,
  publishMetadata,
  isVaultSuperAdmin,
}: ICreateAndPublishAssetParams) {
  return async (dispatch: Dispatch, getState: () => IAppState) => {
    const state = getState();
    const { thumbnailFrame } = state.selectedClipsPreview;
    let publishMetadataToSend = publishMetadata;

    if (thumbnailFrame !== null) {
      if (!isVaultSuperAdmin) {
        toast('Generating Thumbnail', {
          type: toast.TYPE.INFO,
        });
      }
      const thumbnail = await getThumbnail(state);
      publishMetadataToSend = {
        ...publishMetadata,
        thumbnail,
      };
    }

    const [settings] = publishSettings;
    let actionType = ActionType.Publish;
    if (settings.type !== 'lan') {
      if (settings.type === 'yahoo') actionType = ActionType.PublishYahoo;
      else if (settings.type === 'x') actionType = ActionType.PublishTwitter;
      else if (settings.type === 'youtube') actionType = ActionType.PublishYoutube;
    }
    const metadataItems = [
      {
        label: 'description',
        value: publishMetadataToSend.description,
      },
      {
        label: 'publishingId',
        value: publishSettings.map((publish) => publish._id).toString(),
      },
    ];
    if (actionType === ActionType.PublishTwitter) {
      metadataItems.push(
        {
          label: 'whatIsHappening',
          value: publishMetadataToSend.whatIsHappening,
        },
      );
    }
    await createAsset({
      newAsset: {
        title: newAssetTitle,
      },
      metadata: metadataItems,
      actionType,
    })(dispatch, getState);
  };
}
